type ApiErrorLike = { response?: { data?: { message?: string } } };

const isNonEmptyString = (value: unknown): value is string => typeof value === 'string' && value.trim().length > 0;

/**
 * Reads `error.response.data.message` from a rejected `FetchError`-shaped value.
 * Returns `undefined` when the field is missing, empty, or not a string — callers
 * can pass the result straight to a failure action that has its own hardcoded
 * fallback.
 */
export const apiErrorMessage = (error: unknown): string | undefined => {
    const message = (error as ApiErrorLike | undefined)?.response?.data?.message;
    return isNonEmptyString(message) ? message : undefined;
};
